import { FC, ReactNode } from "react";
import { Flex, Heading, Text } from "@chakra-ui/react";

interface Props {
  amount: ReactNode;
  term: ReactNode;
}

export const PlanBoxDiscountedPrice: FC<Props> = ({ amount, term }) => {
  return (
    <Flex mr={2}>
      <Heading
        color="th.gray4"
        textDecorationLine="line-through"
        variant="th-h2"
      >
        {amount}
      </Heading>
      <Text
        color="th.gray4"
        display={{ base: "initial", md: "none" }}
        mt={{ base: 0, md: 4 }}
        variant="th-body3"
      >
        {term}
      </Text>
    </Flex>
  );
};
